// extracted by mini-css-extract-plugin
export var chevron = "_kz-4";
export var chevronExpanded = "_kz-5";
export var row = "_kz-0";
export var rowBody = "_kz-6";
export var rowDescription = "_kz-7";
export var rowHeader = "_kz-1";
export var rowTitle = "_kz-2";
export var rowTitleComplete = "_kz-3";